module.exports = __webpack_public_path__ + "static/media/Home_Banner@2x.1d2b430a.png";